<ng-content/>
<a (click)="toggleShow()" class="type-toggle">
  @if (!showPassword) {
    <ion-icon class="show-option" name="eye-off-outline"/>
  }
  @if (showPassword) {
    <ion-icon class="hide-option" name="eye-outline"/>
  }
</a>
